import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import "./_leadManagement.scss"
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import FollowupHistoryModal from './FollowupHistoryModal';
import LeadUpdateModal from './LeadUpdateModal';
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { Link, withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import moment from "moment";
import ScrollMenu from 'react-horizontal-scrolling-menu';
import MyTaskLeadDetailsModal from './myTaskLeadDetailModal';




const MenuItem = ({ text, selected1, onClick }) => {
    return (
        <Card className={`menu-item ${selected1 ? 'selected-card' : ''}`} onClick={onClick}>
            <Card.Body>
                <div className="card-items" style={{ cursor: 'pointer' }}>
                    <ul >
                        <li className="text-center "><h6>{text.status_count}</h6></li>
                        <li className="text-center ">{text.status_name}</li>
                    </ul>
                </div>
            </Card.Body>
        </Card>
    )
};


export const Menu = (list, selected, onItemClick) =>
    list[0].lead_status_details.map((el, index) => {
        return (
            <MenuItem text={el} key={index} selected1={index == selected} onClick={() => onItemClick(index)} />
        )
    }
    );

const Arrow = ({ text, className }) => (
    <div className={className}>{text}</div>
);


export const ArrowLeft = Arrow({ text: <i className="fas fa-chevron-left"></i>, className: 'arrow-prev' });
export const ArrowRight = Arrow({ text: <i className="fas fa-chevron-right"></i>, className: 'arrow-next' });


class MyRecords extends Component {
    constructor(props) {
        super(props)
        this.state = {
            blockType: "1",
            getLeadTaskStatusDetails: this.props.getLeadTaskStatusDetails,
            getCallStatusTypes: this.props.getCallStatusTypes,
            getLeadStatusTypes: this.props.getLeadStatusTypes,
            selectedCardData: [],
            showDetailsCard: true,
            selectCardStatusName: "",
            followupHistoryModal: false,
            leadUpdateModal: false,
            lead_id: "",
            followUpData: [],
            alignCenter: false,
            clickWhenDrag: false,
            hideArrows: false,
            dragging: true,
            hideSingleArrow: true,
            translate: 0,
            transition: 0.4,
            wheel: true,
            inertiascrolling: false,
            slowdownFactor: 0.25,
            selected: 0,
            // is_update: true,
            myTaskLeadDetailsModal: false,
            myTaskrowData: [],
            loadingSpinner:0,
            fieldsData:[]
        }
        this.menu = React.createRef();
    }


    onUpdate = ({ translate }) => {
        this.setState({ translate });
    };



    handleItemClick = (index) => {
        const firstLeadDetails = this.state.getLeadTaskStatusDetails[0].lead_status_details[index]?.lead_details;
        const statusName = this.state.getLeadTaskStatusDetails[0].lead_status_details[index].status_name;
        this.setState({ selected: index, selectedCardData: firstLeadDetails, selectCardStatusName: statusName });
    };


    articlecolumns = [
        {
            dataField: "lead_name",
            text: " Lead Name",
            sort: true,
            formatter: this.myTaskleadDetails.bind(this)
        },
        {
            dataField: "lead_mobile",
            text: " Lead Mobile",
            sort: true,
        },
        // {
        //     dataField: "source_name",
        //     text: "Source",
        //     sort: true,
        // },
        {
            dataField: "comment",
            text: "Comment",
            sort: true,
        },
        {
            dataField: "call_status",
            text: "Call Status",
            sort: true,
        },
        {
            dataField: "next_followp_date",
            text: "Next Followup Date",
            sort: true,
        },
        {
            dataField: "",
            text: "Lead Update & History",
            sort: false,
            formatter: this.leadUpdate.bind(this)
        },
        // {
        //     dataField: "",
        //     text: "History",
        //     sort: true,
        //     formatter: this.followupHistory.bind(this)
        // },

    ];

    followupHistory(row, col) {
        console.log("rowwww", row, col);
        return (
            <Button
                variant="link"
                name="view"
                className="text-theme"
                onClick={() => {
                    this.setState({ followupHistoryModal: true, lead_id: col.lead_id })
                }}
            >
                <i className="fas fa-eye text-primary mr-2" style={{ fontSize: "18px" }} />
            </Button>
        );
    }


    leadUpdate(row, col) {
        console.log("collllllll", col)
        return (
            <Button variant="link" name="view" className="text-theme" onClick={() => { this.setState({ leadUpdateModal: true, rowData: col, lead_id: col.lead_id }) }}>
                <i className="fal fa-edit" />
            </Button>
        )
    }

    getFormFieldsData = async (val) => {

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int, $branch_id:Int, $lead_id:Int! ) {
                getFormFieldsData(institute_id:$institute_id, branch_id:$branch_id, lead_id: $lead_id) {
                    form_fields_id
                    form_field_name
                    lead_id
                    lead_mobile
                    lead_name
                    value
                }
              }
            `,
            variables: {
                institute_id:parseInt(Cookies.get("institutionid")),
                branch_id:parseInt(Cookies.get("branch_id")),
                lead_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getFormFieldsData.length > 0) {
            let data = result.data.getFormFieldsData;
            this.setState({ fieldsData: data, loadingSpinner1: 0 })
        } else {
            this.setState({ fieldsData: [], loadingSpinner1: 0 })
        }
    }

    myTaskleadDetails(val, row, col) {
        console.log(row, col, "wwwwww")
        return (<>
            <div>
                <a
                    href="#"
                    // onClick={() => this.setState({ myTaskLeadDetailsModal: true, myTaskrowData: row.totalRowData })}
                    onClick={() => this.getFormData(row.lead_id, row.totalRowData)}
                    style={{color: "#000", textDecoration: "none"}}
                    onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                    onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                >
                    {row.lead_name}
                </a>
            </div>
        </>)
    };
    getFormData = (value, data) =>{
        this.getFormFieldsData(value)
        setTimeout(() => {
            this.setState({
                myTaskLeadDetailsModal: true,
                myTaskrowData: data
            })
                }, 600)
        
    }

    tableData(data) {
        console.log("data", data)
        let returnData = [];
        data.map((item) => {
            let call_status = this.props.getCallStatusTypes.filter((a) => a.id == item.calling_status_id)
            console.log("item", call_status);
            const newObj = {
                lead_id: item.lead_id,
                lead_status_type_id: item.lead_status_type_id,
                lead_name: item.lead_name || "-",
                lead_mobile: item.lead_mobile || "-",
                father_name: item.father_name || "-",
                father_contact_no: item.father_contact_no || "-",
                // source_name: item.source_name || "-",
                comment: item.comments || "-",
                call_status: call_status[0]?.calling_status || "-",
                state_name: item.state_name || "-",
                next_followp_date: item.next_followp_date ? moment.unix(item.next_followp_date).format("DD MMM YYYY") : "-",
                totalRowData: item
            }
            returnData.push(newObj);
        });
        return returnData;
    }

    componentDidMount() {
        console.log("ssss", this.state.getLeadTaskStatusDetails);
        if (this.state.getLeadTaskStatusDetails[0].lead_status_details.length > 0) {
            const firstLeadDetails = this.state.getLeadTaskStatusDetails[0].lead_status_details[0]?.lead_details;
            const statusName = this.state.getLeadTaskStatusDetails[0].lead_status_details[0].status_name;
            this.setState({ selectedCardData: firstLeadDetails, selectCardStatusName: statusName });
        }
    }

    render() {
        console.log("first", this.state.selectedCardData)

        const { alignCenter, clickWhenDrag, hideArrows, dragging, hideSingleArrow, translate, transition, wheel, inertiascrolling, slowdownFactor, selected } = this.state;

        const menu = Menu(this.state.getLeadTaskStatusDetails, selected, this.handleItemClick);

        return (
            <section className="my-record">
                <Container >
                    <div>
                        <ScrollMenu
                            alignCenter={alignCenter}
                            arrowLeft={ArrowLeft}
                            arrowRight={ArrowRight}
                            data={menu}
                            dragging={dragging}
                            hideArrows={hideArrows}
                            hideSingleArrow={hideSingleArrow}
                            inertiaScrolling={inertiascrolling}
                            inertiaScrollingSlowdown={slowdownFactor}
                            ref={this.menu}
                            rtl={false}
                            scrollBy={0}
                            transition={+transition}
                            translate={translate}
                            useButtonRole={true}
                            wheel={wheel}
                            onUpdate={this.onUpdate}
                        />
                    </div>
                    <Row className="mt-2">
                        {
                            this.state.getLeadTaskStatusDetails[0].lead_status_details.length > 0 ? (
                                <>
                                    {this.state.selectedCardData.length > 0 ? (
                                        <Col sm={12} md={12}>
                                            <Card className="table-border">
                                                <Card.Body>
                                                    <Row>
                                                        <Col xl={12} lg={12} md={12} sm={12}>
                                                            <CardLessDataTableWithSearch
                                                                parentData={this.tableData(this.state.selectedCardData)}
                                                                particlecolumns={this.articlecolumns}
                                                                name="leads"
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ) : (
                                        <>
                                            <Row>
                                                <Col lg={12} md={12} sm={12}>
                                                    <h6 className='no_data'>No Leads Available</h6>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </>
                            ) : (
                                <Row>
                                    <Col lg={12} md={12} sm={12}>
                                        <h6 className='no_data'>No Leads Available</h6>
                                    </Col>
                                </Row>
                            )
                        }

                    </Row>
                    <FollowupHistoryModal
                        stateData={this.state}
                        show={this.state.followupHistoryModal}
                        onHide={() => this.setState({ followupHistoryModal: false, lead_id: "" })}
                    />
                    <LeadUpdateModal
                        stateData={this.state}
                        show={this.state.leadUpdateModal}
                        onHide={() => this.setState({ leadUpdateModal: false })}
                    />
                    <MyTaskLeadDetailsModal
                        stateData={this.state}
                        show={this.state.myTaskLeadDetailsModal}
                        onHide={() => this.setState({ myTaskLeadDetailsModal: false })}
                    />
                </Container>
            </section>
        )
    }
}

export default withRouter(withApollo(compose(
)(MyRecords)));